<template>
  <vz-dialog
    ref="dialog"
    title="Применить шаблон"
    :loader="useSpinner"
    name="vz-template-modal"
    small
    hide-footer
    @showed="showed"
  >
    <div class="mt-10">
      <vz-input
        placeholder="Поиск"
        icon-name="magnify"
        @update:modelValue="debouncedSearch"
      />
      <div class="mt-30 mb-10">
        <div>
          Ваши шаблоны
        </div>
        <div class="template-autocomplete-list-items">
          <vz-card
            v-for="item of items"
            class="template-autocomplete-list-item"
            @click="onChange(item)"
          >
            <vz-star-checkbox
              size="16"
              readonly
              :model-value="!!getItemVariant(item)"
              :variant="getItemVariant(item)"
            />
            <span>{{ item.name }}</span>
          </vz-card>
        </div>
        <div v-if="!items.length && !useSpinner" class="vz-new-autocomplete-list-item active">
          <slot name="no-data">
            <div class="vz-new-autocomplete-list-item-title color-light">
              <span v-if="searchValue">Шаблоны по запросу "{{ searchValue }}" не найдены</span>
              <template v-else>
                <span>Список шаблонов пуст.</span>
                <nuxt-link :to="{ name: 'personal-order-template-id' }"> Новый шаблон</nuxt-link>
              </template>
            </div>
          </slot>
        </div>
      </div>
    </div>
  </vz-dialog>
</template>

<script setup lang="ts">
import VzDialog from '~/components/ui-kit/vz-dialog.vue';
import VzInput from "~/components/ui-kit/vz-input.vue";
import {useDebounceFn} from "@vueuse/core";
import {getTemplateList} from "~/api/template";
import {TemplateOrder} from "~/types/order/orderV3";
import VzCard from "~/components/ui-kit/vz-card.vue";
import VzStarCheckbox from "~/components/ui-kit/vz-star-checkbox.vue";

const emit = defineEmits([
  'select'
])

const props = defineProps({

})

const { $hideDialog } = useNuxtApp()
let controller = new AbortController()
const debouncedSearch = useDebounceFn((val: string) => { search(val) }, 300, { maxWait: 3000 })

const searchValue = ref('')
const items = ref([] as TemplateOrder[])
const useSpinner = ref(false)

function getItemTitle(template: TemplateOrder) {
  if (template.default) {
    return 'По умолчанию'
  }
  if (template.favorite) {
    return 'Избранное'
  }
  return ''
}

function getItemVariant(template: TemplateOrder) {
  if (template.default) {
    return 'primary'
  }
  if (template.favorite) {
    return 'warning'
  }
  return ''
}

async function search(value?: string) {
  controller.abort()
  searchValue.value = value || ''
  useSpinner.value = true
  controller = new AbortController()
  items.value = (await getTemplateList({ name: value }, controller.signal)).data

  useSpinner.value = false
}

function onChange(value: TemplateOrder) {
  emit('select', value)
  $hideDialog({ name: 'vz-template-modal' })
}

function showed() {
  search()
}
</script>
